module.exports = __webpack_public_path__ + "img/slider-bg.538a3994.svg";